/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IncludeOption = {
    Texts: 'TEXTS',
    Parameters: 'PARAMETERS'
} as const;
export type IncludeOption = typeof IncludeOption[keyof typeof IncludeOption];


export function instanceOfIncludeOption(value: any): boolean {
    for (const key in IncludeOption) {
        if (Object.prototype.hasOwnProperty.call(IncludeOption, key)) {
            if (IncludeOption[key as keyof typeof IncludeOption] === value) {
                return true;
            }
        }
    }
    return false;
}

export function IncludeOptionFromJSON(json: any): IncludeOption {
    return IncludeOptionFromJSONTyped(json, false);
}

export function IncludeOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncludeOption {
    return json as IncludeOption;
}

export function IncludeOptionToJSON(value?: IncludeOption | null): any {
    return value as any;
}

export function IncludeOptionToJSONTyped(value: any, ignoreDiscriminator: boolean): IncludeOption {
    return value as IncludeOption;
}

